import type { Release } from '../releases.ts';

export default {
  version: '0.94.1',
  date: '2026-10-09',
  title: 'PRISM Graphics v1.0.0-rc.1 samples',
  summary: [
    'The deployment guide names the PRISM Graphics release to install, v1.0.0-rc.1, and what its checks answer',
    'Fixed: the tests use the v1.0.0-rc.1 samples, whose video graphics wait for each frame',
  ],
  features: [
    'Deployment guide for PRISM Graphics: it names the release to install, v1.0.0-rc.1, and shows what the health and readiness checks answer',
  ],
  fixes: [
    'OGraf graphics: PRISM’s tests use the PRISM Graphics samples from v1.0.0-rc.1, whose video graphics wait correctly for each video frame under PRISM’s renderer',
  ],
} satisfies Release;
